export interface GeocodeResult {
	results: google.maps.GeocoderResult[] | null;
	status: google.maps.GeocoderStatus;
}

export const DEFAULT_COUNTRY_ID = 'MX';
const DEFAULT_LANGUAGE = 'es';
const DEFAULT_REGION = 'MX';

/**
 * Geocodes by zip code using Google Maps JS API.
 * Returns a Promise so it can be awaited inside client components.
 */
export const geocodeByZipCode = (
	zipCode?: string,
	address?: string,
	country?: string | undefined,
	language: string = DEFAULT_LANGUAGE,
	region: string = DEFAULT_REGION
): Promise<{
	results: google.maps.GeocoderResult[] | null;
	status: google.maps.GeocoderStatus;
}> =>
	new Promise((resolve, reject) => {
		if (typeof window === 'undefined' || !window.google) {
			reject(new Error('Google Maps JS SDK is not loaded'));
			return;
		}

		const geocoder = new window.google.maps.Geocoder();

		geocoder.geocode(
			{
				...(address && { address }),
				componentRestrictions: {
					...(country && { country }),
					...(zipCode && { postalCode: zipCode }),
				},
				language,
				region,
			},
			(results, status) => {
				if (
					status === google.maps.GeocoderStatus.OK ||
					status === google.maps.GeocoderStatus.ZERO_RESULTS
				) {
					resolve({ results, status });
				} else {
					resolve({ results: [], status });
				}
			}
		);
	});
